export default function TopicsSection() {
  const topics = [
    { name: '顶流恋情', heat: '987万', cls: 'bg-primary-100 text-primary-700 border-primary-200' },
    { name: '新剧开播', heat: '856万', cls: 'bg-accent-100 text-accent-800 border-accent-200' },
    { name: '综艺名场面', heat: '743万', cls: 'bg-secondary-100 text-secondary-700 border-secondary-200' },
    { name: '机场时尚', heat: '691万', cls: 'bg-primary-50 text-primary-600 border-primary-100' },
    { name: '离婚风波', heat: '628万', cls: 'bg-accent-50 text-accent-700 border-accent-100' },
    { name: '代言官宣', heat: '554万', cls: 'bg-secondary-50 text-secondary-600 border-secondary-100' },
    { name: '颁奖典礼', heat: '487万', cls: 'bg-primary-100 text-primary-700 border-primary-200' },
    { name: '私生饭事件', heat: '432万', cls: 'bg-accent-100 text-accent-800 border-accent-200' },
    { name: '翻唱出圈', heat: '398万', cls: 'bg-secondary-100 text-secondary-700 border-secondary-200' },
    { name: '古装造型', heat: '361万', cls: 'bg-primary-50 text-primary-600 border-primary-100' },
  ];

  return (
    <section id="topics" className="py-16 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          热门话题
        </h2>
        <div className="flex flex-wrap items-center justify-center gap-3">
          {topics.map((t) => (
            <div
              key={t.name}
              className={`flex items-center gap-2 px-4 py-2.5 rounded-full border cursor-pointer transition-all hover:-translate-y-0.5 ${t.cls}`}
            >
              <span className="text-sm font-medium whitespace-nowrap">{t.name}</span>
              <span className="text-xs opacity-70 whitespace-nowrap">{t.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}